// extracted by mini-css-extract-plugin
module.exports = {"switchButtonRow":"switchButtonRow_switchButtonRow__wXMCn","switchTitle":"switchButtonRow_switchTitle__Y3Kou","switchDescription":"switchButtonRow_switchDescription__1iVZr"};